import React from "react";
import "./rules.css"
import {usePumpStore} from "../../store/pumpStore";
import parse from "html-react-parser";
import {Locales} from "../../helpers/localeHelpers";


export const Rules = ({setPageName}) => {
    const {language} = usePumpStore()

    return (
        <div className={"rules-wrapper"}>
            {Locales[language].rules.map((item, index) => (
                <React.Fragment key={index}>
                    {parse(item)}
                </React.Fragment>
            ))}
            <button className={'close-btn'} onClick={() => setPageName('main')}>Ок</button>
        </div>
    )
}